import React from 'react';
import {
  Col, Divider, Form, InputNumber, Row,
} from 'antd';
import { AnyObject } from '@triare/auth-redux';
import { GuaranteesInfo } from '../../../../../hooks/api/tariffs';

export const guarantiesFormItems: { name: keyof GuaranteesInfo, label: string, placeholder?: boolean; }[] = [
  {
    name: 'basicPrice',
    label: 'grüüün Gebühr (Basic Price)',
  },
  {
    name: 'basicPricePeriod',
    label: 'Grundpreis period (Basic Price Period)',
  },
  {
    name: 'energyPrice',
    label: 'Energiepreis netto (Energy Price)',
  },
  {
    name: 'energyPricePeriod',
    label: 'Energiepreis period (Energy Price Period)',
  },
  {
    name: 'basicPrice',
    label: '-',
    placeholder: true,
  },
  {
    name: 'numberOfMonths',
    label: 'Netto-Preisgarantie (period)',
  },
];

interface GuarantiesFieldsProps {
  id?: number;
  restField?: AnyObject;
}

function GuarantiesFields({ id, restField = {} }: GuarantiesFieldsProps) {
  const prefixArr = ['tooltips', 'guaranties'];

  if (id !== undefined) {
    prefixArr.unshift(String(id));
  }

  return (
    <>
      <Divider>Guaranties</Divider>
      <Row gutter={12}>
        {guarantiesFormItems.map(({ name, label, placeholder }) => (
          <Col span={12} key={`${name}-${placeholder}`}>
            {placeholder ? null : (
              <Form.Item
                {...restField}
                label={label}
                name={id !== undefined ? [id, name] : name}
                rules={[{ required: false, message: 'Please enter' }]}
                normalize={(value) => value && Number.parseFloat(value.toFixed(2))}
              >
                <InputNumber placeholder="Please enter" style={{ width: '100%' }} step={1} />
              </Form.Item>
            )}
          </Col>
        ))}
      </Row>
    </>
  );
}

export default GuarantiesFields;
